import { createAction } from 'redux-actions';
import * as types from './direct-routes-handler-constants';

export const getRedirectInfoRequest = createAction(types.GET_REDIRECT_INFO_REQUEST);
export const getRedirectInfoSuccess = createAction(types.GET_REDIRECT_INFO_SUCCESS);
export const getRedirectInfoFailure = createAction(types.GET_REDIRECT_INFO_FAILURE);
